import DELETE_FREE_TAG_SPEC_ITEM from './deleteFreeTagSpecItem.graphql'
export default DELETE_FREE_TAG_SPEC_ITEM
